import type { BFFArticleBodyElement } from "@src/app/types/bff";

export default function ArticleSubHead({
  element,
}: {
  element: BFFArticleBodyElement["sub_head"];
}) {
  return (
    <h2 className="pb-4 text-justify text-header-2 text-primary">
      {element.value}
    </h2>
  );
}
